import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';
import { OnlineEnquiryLogComponent } from '../online-enquiry-log/online-enquiry-log.component';

@Component({
  selector: 'app-online-payment-log',
  templateUrl: './online-payment-log.component.html',
  styleUrls: ['./online-payment-log.component.scss']
})
export class OnlinePaymentLogComponent implements OnInit {
  from_date: any;
  title = null;
  to_date: any;
  is_data_available: boolean = true;
  payment_log_data: any = [];
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  constructor(private httpService: HttpService, private dialog: MatDialog, private global:GlobalService) {
    this.title = this.global._active_display_name;
  }

  ngOnInit() {
  }

  checkBorderColor(status_name, auto_enquiry_status) {
    if (auto_enquiry_status === 'Success' || status_name === 'Success') {
      return '20px solid green';
    } else if (auto_enquiry_status === 'Failed') {
      return '20px solid red';
    } else if (auto_enquiry_status === 'Pending') {
      return '20px solid yellow';
    } else {
      return '20px solid gray';
    }
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.is_data_available = false;
    this.httpService.serveOnlinePaymentLog(data_dict).subscribe((data) => {
      console.log(data);
      this.payment_log_data = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  enqiryCalled(rid) {
    const dialogRef = this.dialog.open(OnlineEnquiryLogComponent, {
      height: '700px',
      width: '900px',
      data: {
        'rid': rid,
      },
      // disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getClicked();
    });
  }
}
